export default {
  workstation: {
    tabs: {
      workstation: "Workstation",
    },
    filters: {
      withAll: "With All",
      withoutAny: "Without Any",
      withPlayer: "With {{player}}",
      withoutPlayer: "Without {{player}}",
      all: "All",
      versusPosition: "vs {{position}}",
      starter: "Starter",
      nonStarter: "Non-starter",
      starterAndNonStarter: "Starter + Non-starter",
      betType: "Bet Type",
      timeframe: "Timeframe",
      splits: "Splits",
      with: "With",
      without: "Without",
      opponent: "Opponent",
    },
    actions: {
      applyFilter: "Apply Filter",
      applied: "Applied",
    },
    banners: {
      notPlayingToday: "{{entity}} is not playing today",
    },
    sections: {
      stats: "Stats",
      seasonStats: "Season Stats",
      last3Seasons: "Last 3 seasons",
      batterVsPitcherGamelog: "View Batter vs. Pitcher Gamelog",
    },
    stats: {
      perGame: "Per game",
      total: "Total",
      timeframe: "Timeframe",
      filters: "Filters",
      season: "Season",
    },
    headers: {
      type: "Type",
      hitRate: "Hit Rate",
      odds: "Odds",
      stat: "Stat",
      average: "Average",
    },
    outcomes: {
      covered: "Covered",
      yes: "Yes",
      no: "No",
      win: "W",
      loss: "L",
      tie: "TIE",
    },
    alerts: {
      imageSavedToDevice: "Image saved to device",
    },
  },
};
